module.exports = __webpack_public_path__ + "static/img/xzicon05.png";